
import Vue from "vue";
import { toggleFilter } from "../store/actions";
import { ITemplateFilter } from "../store/state";

interface CheckboxProperty {
  filter: ITemplateFilter;
}
interface CheckboxComputed {
  selected: boolean;
  hitsLength: number;
}
export default Vue.extend<{}, {}, CheckboxComputed, CheckboxProperty>({
  name: "Checkbox",
  props: {
    filter: {},
  },
  methods: {
    toggleSelected(e: any) {
      if (e.key === "Enter") {
        const filter = this.$store.getters.templateFilter.find(
          (f: ITemplateFilter) => f.id === this.$props.filter.id
        );
        this.$store.dispatch(
          toggleFilter({
            id: this.$props.filter.id,
            value: !filter.selected,
          })
        );
      }
    },
  },
  computed: {
    selected: {
      get() {
        const filter = this.$store.getters.templateFilter.find(
          (f: ITemplateFilter) => f.id === this.$props.filter.id
        );
        return filter.selected;
      },
      set(value) {
        this.$store.dispatch(
          toggleFilter({
            id: this.$props.filter.id,
            value: value,
          })
        );
      },
    },
    hitsLength() {
      let searchResult = this.$store.getters.searchResult;
      let currentFiltersHits = searchResult.searchHits[this.filter.name] || [];
      return currentFiltersHits.length;
    },
  },
});
